import { RepairShopResponse } from './models/RepairShop';

const useApi = <R, B>(url: string, method: string) => {
  const execute = async (body?: B) => {
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.error?.code?.toString());
    }

    return (await response.json()) as R;
  };

  return execute;
};

export const usePostSearchShop = () => {
  return useApi<RepairShopResponse, { municipality: string; registrationNumber: string }>('/api/search/shop', 'POST');
};

const post = async <R, B>(url: string, data: B): Promise<R> => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData?.error?.code?.toString());
  }

  return (await response.json()) as R;
};

export const postSearchShop = async (
  municipality: string,
  registrationNumber: string,
  windshieldRepair?: boolean
): Promise<RepairShopResponse> => {
  return post(`/api/search/shop`, {
    municipality,
    registrationNumber,
    ...(windshieldRepair ? { windshieldRepair } : {}),
  });
};
